import { useState } from 'react';

import breakpoints from 'theme/breakpoints';
import Breakpoint from 'types/Breakpoint';
import useEventListener from 'hooks/useEventListener';
import keysOf from 'utils/keysOf';
import isBrowser from 'utils/isBrowser';

const getBreakpoint = (): Breakpoint | undefined =>
  (isBrowser || undefined) && keysOf(breakpoints).find((key) => window.innerWidth < breakpoints[key]);

/**
 * !!! DO NOT USE IT FOR CONDITIONAL RENDERING !!!
 */
const useBreakpoint = (): Breakpoint | undefined => {
  const [breakpoint, setBreakpoint] = useState(getBreakpoint());

  useEventListener('resize', () => {
    setBreakpoint(getBreakpoint());
  });

  return breakpoint;
};

export default useBreakpoint;
